import React, { useEffect, useState } from "react";
import { fetchNewsDatabase } from "../../services/nocodb";
import sortByDate from "./../../helpers/sortByDate";

import ListItem from "./ListItem";

const CACHE_KEY = "cachedNews";
const CACHE_EXPIRY_MS = 1000 * 60 * 60; // 1 hour

function List() {
  const [news, setNews] = useState([]);
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNews();
  }, [reload]);

  async function getNews() {
    const cached = localStorage.getItem(CACHE_KEY);
    const cachedTime = localStorage.getItem(`${CACHE_KEY}_timestamp`);

    const now = Date.now();
    const isCacheValid = cached && cachedTime && now - cachedTime < CACHE_EXPIRY_MS;

    if (isCacheValid) {
      try {
        const cachedData = JSON.parse(cached);
        sortByDate(cachedData);
        setNews(cachedData);
        setLoading(false);
        return;
      } catch (e) {
        console.warn("Corrupted cache, refetching...");
      }
    }

    try {
      const data = await fetchNewsDatabase();
      sortByDate(data);
      setNews(data);
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      localStorage.setItem(`${CACHE_KEY}_timestamp`, now.toString());
    } catch (err) {
      console.error("Error loading data from NocoDB", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className={"loader"}></div>;

  return (
    <div className="row">
      {news && news.map(news => (
        <ListItem
          key={news.Id}
          news={news}
          setReload={setReload}
        />
      ))}
    </div>
  );
}

export default List;